// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"50b647ba","800":"d26387da"}[chunkId] + ".chunk.js";
};